import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Review } from '@app/core/interfaces';

@Component({
    selector: 'ins-review-list',
    templateUrl: 'review-list.component.html',
    styleUrls: ['./review-list.component.scss', '../review.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewListComponent {
    @Input() reviews: Review[];
    @Input() totalPages: number;
    @Output() readonly pageSelected: EventEmitter<number> = new EventEmitter();

    public pageSelectedHandler(pageNumber: number) {
        this.pageSelected.emit(pageNumber);
    }
}
